const IssueReceipt = {
  type: 'IssueReceipt',
  dropdown: {
    valueKey: 'value',
    labelKey: 'label',
    isEnum: true,
  },
};

export default IssueReceipt;
